import Immutable from 'immutable';

import {
	createModuleState,
	createModelForState,
	webapi,
	REPORTED_EXCEPTION,
	DateUtils,
} from 'ps-gui';

const EMPTY_LIST = Immutable.List([]);
const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('LabelAdmin');



export default class LabelAdminModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new LabelAdminModel(this.#data.setIn(name, value));
		} else {
			return new LabelAdminModel(this.#data.set(name, value));
		}
	}

	#deleteProperty(name) {
		if (Array.isArray(name)) {
			return new LabelAdminModel(this.#data.deleteIn(name));
		} else {
			return new LabelAdminModel(this.#data.delete(name));
		}
	}

	#setInitialized() {
		return new LabelAdminModel(this.#data.set('initialized', true));
	}

	setLockedFromDate(value) {
		return this.#setProperty('lockedFromDate', value);
	}

	setLockedToDate(value) {
		return this.#setProperty('lockedToDate', DateUtils.getEndOfDay(value));
	}

	async save() {
		const res = await webapi.execute('/api/proc/api_labels/setLockedDates', {
			lockedFromDate: DateUtils.formatRawDateTime(DateUtils.getStartOfDay(this.#data.get('lockedFromDate'))),
			lockedToDate: DateUtils.formatRawDateTime(DateUtils.getEndOfDay(this.#data.get('lockedToDate')))
		});
		if (res === REPORTED_EXCEPTION) {
			return this;
		}
		return this.initialize();
	}

	async checkGlobalContextChange(globalContext) {
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		let model = this;
		model = await model.initialize(globalContext);
		return model.#setProperty('languageTimestamp', new Date().getTime());
	}


	async initialize() {

		let pi = await webapi.execute('/api/proc/api_labels/getadmininfo', {});
		if (pi === REPORTED_EXCEPTION) {
			return this;
		}
		let model = this.#setProperty('lockedFromDate', pi.config.lockedFromDate).#setProperty('lockedToDate', pi.config.lockedToDate).#setInitialized();
		return model;
	}

	setSearch(model) {
		return new LabelAdminModel(this.#data.set('search', model.getState()));
	}

	getSearch() {
		return createModelForState(this.#data.get('search'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}


